import { useRef } from "react";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
//to write common helper functions
export function useDebounceFn(fn, delay = 500) {
  const timer = useRef(null);

  return function (...args) {
    // Clear the previous timer if the function is invoked again
    if (timer.current) {
      clearTimeout(timer.current);
    }

    // Set the new timer to invoke the function after the specified delay
    timer.current = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export function addQueryParams(baseUrl, params = {}) {
  const filteredParams = Object.entries(params).filter(
    ([key, value]) =>
      value !== "" &&
      value != null &&
      value !== undefined &&
      !(key === "role" && value === "All")
  );

  const query = new URLSearchParams(filteredParams)?.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
}

export const getYears = () => {
  const existingData = "2021";
  const existingCurrentYear = new Date().getFullYear();
  const additionalData = [];
  for (var i = existingData; i <= existingCurrentYear + 1; i++) {
    additionalData.push(i.toString());
  }
  return additionalData;
};

export const convertDecimalDaysToTime = (decimalDays) => {
  const totalDays = Math.floor(Math.abs(decimalDays));
  const remainingHours = Math.round((Math.abs(decimalDays) % 1) * 24);
  const daysText =
    decimalDays < 0
      ? `-${totalDays} ${totalDays === 0 || totalDays === 1 ? "Day" : "Days"} `
      : `${totalDays} ${totalDays === 0 || totalDays === 1 ? "Day" : "Days"} `;
  const hoursText = `${remainingHours === 24 ? 23 : remainingHours} ${
    remainingHours === 0 || remainingHours === 1 ? "Hour" : "Hours"
  } `;

  return `${daysText}${hoursText}` === "-0 Day 0 Hour "
    ? "0 Day 0 Hour"
    : `${daysText}${hoursText}`;
};
const title = [
  [
    "S.No",
    "Family Name",
    "Nirvana Status",
    "Nirvana Remarks",
    "SRM Name",
    "UpdatedBy",
  ],
];
export const handleExport = (headers = [], data) => {
  const getCellStyle = (val) => {
    const stringValue = String(val);
    const numericValue = parseFloat(stringValue);
    return isNaN(numericValue)
      ? "000000"
      : numericValue === 0
      ? stringValue.startsWith("-")
        ? "E2A42C"
        : "00861D"
      : numericValue < 0
      ? "E22C2C"
      : "00861D";
  };

  const rows = data.flatMap((family, index) => {
    return [
      [
        index + 1,
        family.familyName,
        family.clientStatus,
        family.clientStatus === "ONBOARDING"
          ? family.timelineTask.filter(
              (item) => item.orderNo === 1 && item.status != null
            ).length > 0
            ? "NA"
            : "-"
          : family.task1balanceSla === 0 || family.task1balanceSla === null
          ? ""
          : convertDecimalDaysToTime(family.task1balanceSla),
        family.task1employeeName || "N/A",
        family.clientStatus === "ONBOARDING"
          ? family.timelineTask.filter(
              (item) => item.orderNo === 2 && item.status != null
            ).length > 0
            ? "NA"
            : "-"
          : family.task2balanceSla === 0 || family.task2balanceSla === null
          ? ""
          : convertDecimalDaysToTime(family.task2balanceSla),
        family.task2employeeName || "N/A",
        family.clientStatus === "ONBOARDING"
          ? family.timelineTask.filter(
              (item) => item.orderNo === 3 && item.status != null
            ).length > 0
            ? "NA"
            : "-"
          : family.task3balanceSla === 0 || family.task3balanceSla === null
          ? ""
          : convertDecimalDaysToTime(family.task3balanceSla),
        family.task3employeeName || "N/A",
        family.clientStatus === "ONBOARDING"
          ? family.timelineTask.filter(
              (item) => item.orderNo === 4 && item.status != null
            ).length > 0
            ? "NA"
            : "-"
          : family.task4balanceSla === 0 || family.task4balanceSla === null
          ? ""
          : convertDecimalDaysToTime(family.task4balanceSla),
        family.task4employeeName || "N/A",
        family.clientStatus === "ONBOARDING"
          ? family.timelineTask.filter(
              (item) => item.orderNo === 5 && item.status != null
            ).length > 0
            ? "NA"
            : "-"
          : family.task5balanceSla === 0 || family.task5balanceSla === null
          ? ""
          : convertDecimalDaysToTime(family.task5balanceSla),
        family.task5employeeName || "N/A",
        family.clientStatus === "ONBOARDING"
          ? family.timelineTask.filter(
              (item) => item.orderNo === 6 && item.status != null
            ).length > 0
            ? "NA"
            : "-"
          : family.task6balanceSla === 0 || family.task6balanceSla === null
          ? ""
          : convertDecimalDaysToTime(family.task6balanceSla),
        family.task6employeeName || "N/A",
      ],
    ];
  });

  const finalData = [headers, ...rows];

  return XlsxPopulate.fromBlankAsync()
    .then((workbook) => {
      finalData.forEach((row, rowIndex) => {
        let maxRowHeight = 0;
        row.forEach((cellValue, colIndex) => {
          const cell = workbook.sheet(0).cell(rowIndex + 1, colIndex + 1);
          cell.value(cellValue);
          if (
            colIndex === 3 ||
            colIndex === 5 ||
            colIndex === 7 ||
            colIndex === 9 ||
            colIndex === 11 ||
            colIndex === 13
          ) {
            cell.style({
              fontColor: getCellStyle(cellValue),
            });
          }
          if (colIndex === 0 || colIndex) {
            cell.style({
              horizontalAlignment: "center",
              verticalAlignment: "center",
              wrapText: true,
            });
          }

          const cellHeight = Math.ceil(cellValue.toString().length / 20) * 20;
          if (cellHeight > maxRowHeight) {
            maxRowHeight = cellHeight;
          }
        });
        workbook
          .sheet(0)
          .row(rowIndex + 1)
          .height(maxRowHeight);
      });

      workbook.sheet(0).range("A1:O1").style({
        bold: true,
        horizontalAlignment: "center",
        verticalAlignment: "center",
        fontColor: "000000",
      });
      workbook.sheet(0).row(1).height(25);
      const columnWidths = [
        8, 20, 25, 25, 30, 40, 30, 35, 30, 40, 30, 65, 30, 35, 30,
      ];
      columnWidths.forEach((width, index) => {
        workbook
          .sheet(0)
          .column(index + 1)
          .width(width);
      });

      return workbook.outputAsync();
    })
    .then((blob) => URL.createObjectURL(blob));
};

export const exportNirvana = (data) => {
  const getCellStyle = (val) => {
    const stringValue = String(val);
    const numericValue = parseFloat(stringValue);
    return isNaN(numericValue)
      ? "000000"
      : numericValue === 0
      ? stringValue.startsWith("-")
        ? "E2A42C"
        : "00861D"
      : numericValue < 0
      ? "E22C2C"
      : "00861D";
  };

  return XlsxPopulate.fromBlankAsync()
    .then((workbook) => {
      data.forEach((row, rowIndex) => {
        let maxRowHeight = 0;
        row.forEach((cellValue, colIndex) => {
          const cell = workbook.sheet(0).cell(rowIndex + 1, colIndex + 1);
          cell.value(cellValue);
          if (colIndex === 2 || colIndex === 4 || colIndex === 6) {
            cell.style({
              fontColor: getCellStyle(cellValue),
            });
          }
          if (colIndex === 0 || colIndex) {
            cell.style({
              horizontalAlignment: "center",
              verticalAlignment: "center",
              wrapText: true,
            });
          }

          const cellHeight = Math.ceil(cellValue.toString().length / 20) * 20;
          if (cellHeight > maxRowHeight) {
            maxRowHeight = cellHeight;
          }
        });
        workbook
          .sheet(0)
          .row(rowIndex + 1)
          .height(maxRowHeight);
      });

      workbook.sheet(0).range("A1:N1").style({
        bold: true,
        horizontalAlignment: "center",
        verticalAlignment: "center",
        fontColor: "000000",
      });
      workbook.sheet(0).row(1).height(25);
      const columnWidths = [8, 30, 25, 60, 30, 30];
      columnWidths.forEach((width, index) => {
        workbook
          .sheet(0)
          .column(index + 1)
          .width(width);
      });

      return workbook.outputAsync();
    })
    .then((blob) => URL.createObjectURL(blob));
};

export const sortAndTransformData = (data, selectedOrder) => {
  const sortedData = [...data].sort((a, b) => {
    const percentA =
      (a.completedWithInSlaCount * 100) /
      (a.completedWithInSlaCount + a.completedWithoutSlaCount);
    const percentB =
      (b.completedWithInSlaCount * 100) /
      (b.completedWithInSlaCount + b.completedWithoutSlaCount);

    if (percentA !== percentB) {
      return selectedOrder === "Ascending"
        ? percentA - percentB
        : percentB - percentA;
    } else {
      return selectedOrder === "Ascending"
        ? a.completedWithInSlaCount - b.completedWithInSlaCount
        : b.completedWithInSlaCount - a.completedWithInSlaCount;
    }
  });
  const transformedData = sortedData.map((item) => ({
    ...item,
    completedWithInSlaCountPercent: Math.round(
      (item.completedWithInSlaCount * 100) /
        (item.completedWithInSlaCount + item.completedWithoutSlaCount)
    ),
    completedWithoutSlaCountPercent: Math.round(
      (item.completedWithoutSlaCount * 100) /
        (item.completedWithInSlaCount + item.completedWithoutSlaCount)
    ),
  }));

  return transformedData;
};

export const getMonthAndYear = (isDateString) => {
  if (!isDateString) return { month: "", year: "" };

  const date = new Date(isDateString);

  const month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
    date
  );
  const year = date.getFullYear();

  return { month, year };
};

//to check is the client is currently active for the month
export const isReadOnly = (status) =>
  ["CLOSE", "HOLD", "HOLDFORTHISMONTH"].includes(status);

export const getStatusColor = (isActive) => {
  if (isActive) {
    return "success";
  } else {
    return "error";
  }
};

export const removeExtraSpaces = (input = "") => {
  return input.replace(/^\s+/, "").replace(/\s+/g, " ");
};

export const getUniqueOptions = (options, valueParam = "id") => {
  const seen = new Set();
  return options.filter((option) => {
    const value = valueParam ? option?.[valueParam] : option;
    if (seen.has(value)) return false;
    seen.add(value);
    return true;
  });
};

export const removeEmptyImageTags = (html = "") => {
  return html.replace(/<img\b[^>]*?\bsrc\s*=\s*["']?\s*["']?[^>]*?>/gi, "");
};

export const limitText = (text, limit = 35) => {
  if (text && text?.length > limit) {
    return text.slice(0, limit) + "...";
  }
  return text;
};

export const htmlToPlainText = (html) => {
  if (!html) return "";
  return html
    .replace(/<p[^>]*>/gi, '\n\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .trim();
};

export const convertToHtml = (text) => {
  return text
    .split("\n")
    .map((line) => (line.trim() ? `<p>${line.trim()}</p>` : ""))
    .join("");
};

export const handleDownloadFile = (file) => {
  let url = "";
  if (!file) return;
  if (file?.url) {
    url = file.url;
  } else {
    url = URL.createObjectURL(file);
  }

  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  URL.revokeObjectURL(url);
};

export const formatWebsiteUrl = (value) => {
  if (value && !/^https?:\/\//i.test(value)) {
    return `https://${value}`;
  }
  return value;
}

export const getFileExtension = (filename) => {
  return filename.split(".").pop().toLowerCase();
};

export const getOfficeUrl = (url) => {
  return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`;
};

export const stripHtml = (html = "") =>
  html
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "")
    .replace(/<\/?[^>]+(>|$)/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();

export const getFileIcon = (fileName) => {
  const extension = fileName?.split(".").pop()?.toLowerCase();

  switch (extension) {
    case "pdf":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 14 14"
          // fill="none"
        >
          <g clipPath="url(#clip0_939_2847)">
            <path d="M0.117188 2.16065C0.117188 1.26194 0.847873 0.53125 1.74659 0.53125H5.8201V3.79006C5.8201 4.24069 6.18417 4.60476 6.6348 4.60476H9.89361V8.27092H4.59805C3.69933 8.27092 2.96864 9.0016 2.96864 9.90032V13.5665H1.74659C0.847873 13.5665 0.117188 12.8358 0.117188 11.9371V2.16065ZM9.89361 3.79006H6.6348V0.53125L9.89361 3.79006ZM4.59805 9.49297H5.41275C6.19945 9.49297 6.83848 10.132 6.83848 10.9187C6.83848 11.7054 6.19945 12.3444 5.41275 12.3444H5.0054V13.1591C5.0054 13.3832 4.82209 13.5665 4.59805 13.5665C4.374 13.5665 4.1907 13.3832 4.1907 13.1591V9.90032C4.1907 9.67628 4.374 9.49297 4.59805 9.49297ZM5.41275 11.5297C5.75136 11.5297 6.02378 11.2573 6.02378 10.9187C6.02378 10.5801 5.75136 10.3077 5.41275 10.3077H5.0054V11.5297H5.41275ZM7.85685 9.49297H8.67156C9.34623 9.49297 9.89361 10.0403 9.89361 10.715V12.3444C9.89361 13.0191 9.34623 13.5665 8.67156 13.5665H7.85685C7.63281 13.5665 7.4495 13.3832 7.4495 13.1591V9.90032C7.4495 9.67628 7.63281 9.49297 7.85685 9.49297ZM8.67156 12.7518C8.8956 12.7518 9.07891 12.5685 9.07891 12.3444V10.715C9.07891 10.491 8.8956 10.3077 8.67156 10.3077H8.26421V12.7518H8.67156ZM10.7083 9.90032C10.7083 9.67628 10.8916 9.49297 11.1157 9.49297H12.3377C12.5618 9.49297 12.7451 9.67628 12.7451 9.90032C12.7451 10.1244 12.5618 10.3077 12.3377 10.3077H11.523V11.1224H12.3377C12.5618 11.1224 12.7451 11.3057 12.7451 11.5297C12.7451 11.7538 12.5618 11.9371 12.3377 11.9371H11.523V13.1591C11.523 13.3832 11.3397 13.5665 11.1157 13.5665C10.8916 13.5665 10.7083 13.3832 10.7083 13.1591V9.90032Z" />
          </g>
          <defs>
            <clipPath id="clip0_939_2847">
              <rect
                width="13.0352"
                height="13.0352"
                fill="white"
                transform="translate(0.117188 0.53125)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case "docx":
      return (
        <svg
          viewBox="0 0 384 512"
          xmlns="http://www.w3.org/2000/svg"
          width="18px"
          height="18px"
        >
          <path d="M224 128L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V160h-127.1C238.3 160 224 145.7 224 128zM281.5 240h23.37c7.717 0 13.43 7.18 11.69 14.7l-42.46 184C272.9 444.1 268 448 262.5 448h-29.26c-5.426 0-10.18-3.641-11.59-8.883L192 329.1l-29.61 109.1C160.1 444.4 156.2 448 150.8 448H121.5c-5.588 0-10.44-3.859-11.69-9.305l-42.46-184C65.66 247.2 71.37 240 79.08 240h23.37c5.588 0 10.44 3.859 11.69 9.301L137.8 352L165.6 248.9C167 243.6 171.8 240 177.2 240h29.61c5.426 0 10.18 3.641 11.59 8.883L246.2 352l23.7-102.7C271.1 243.9 275.1 240 281.5 240zM256 0v128h128L256 0z" />
        </svg>
      );
    case "xlsx":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="18px"
          width="18px"
          viewBox="0 0 384 512"
        >
          <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z" />
        </svg>
      );
    case "png":
    case "jpg":
    case "jpeg":
    case "svg":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="18px"
          width="18px"
          viewBox="0 0 384 512"
        >
          <path d="M384 121.9V128H256V0h6.1a24 24 0 0 1 17 7l97.9 97.9a24 24 0 0 1 7 17zM248 160c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248zm-135.5 16c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm208 240h-256l.5-48.5L104.5 328c4.7-4.7 11.8-4.2 16.5 .5L160.5 368 264.1 264.5c4.7-4.7 12.3-4.7 17 0L320.5 304v112z" />
        </svg>
      );
    default:
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          shape-rendering="geometricPrecision"
          text-rendering="geometricPrecision"
          image-rendering="optimizeQuality"
          fill-rule="evenodd"
          clip-rule="evenodd"
          viewBox="0 0 414 512.01"
          width="18px"
          height="18px"
        >
          <path d="M35.95 0h213.36v146.7c0 5.51 4.47 9.98 9.98 9.98H414v319.39c0 9.83-4.04 18.81-10.55 25.34l-.08.08c-6.53 6.49-15.49 10.52-25.31 10.52H35.95c-9.9 0-18.89-4.04-25.4-10.55C4.04 494.95 0 485.96 0 476.07V35.94c0-9.89 4.04-18.88 10.55-25.39C17.06 4.04 26.05 0 35.95 0zm233.33 2.23a13.2 13.2 0 012.49 2.17l136.55 132.31H269.28V2.23zM91.31 419.73c-5.52 0-9.99-4.47-9.99-9.98 0-5.51 4.47-9.99 9.99-9.99h231.38c5.52 0 9.99 4.48 9.99 9.99s-4.47 9.98-9.99 9.98H91.31zm0-76.35c-5.52 0-9.99-4.47-9.99-9.98 0-5.52 4.47-9.99 9.99-9.99h227.78c5.52 0 9.99 4.47 9.99 9.99 0 5.51-4.47 9.98-9.99 9.98H91.31zm0-76.35c-5.52 0-9.99-4.47-9.99-9.99 0-5.51 4.47-9.98 9.99-9.98h184.31c5.51 0 9.99 4.47 9.99 9.98 0 5.52-4.48 9.99-9.99 9.99H91.31zm0-76.36c-5.52 0-9.99-4.47-9.99-9.98 0-5.52 4.47-9.99 9.99-9.99h102.9c5.52 0 9.99 4.47 9.99 9.99 0 5.51-4.47 9.98-9.99 9.98H91.31zm0-76.35c-5.52 0-9.99-4.47-9.99-9.99 0-5.51 4.47-9.98 9.99-9.98h55.41c5.52 0 9.99 4.47 9.99 9.98 0 5.52-4.47 9.99-9.99 9.99H91.31z" />
        </svg>
      );
  }
};

export const downloadFileLocal = (file) => {
  const blob = new Blob([file], { type: file.type });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(url);
  document.body.removeChild(a);
};